import React from "react";
import bg_dot_hero from '../assets/img/Illustrations/smaller_dots_bg_hero.avif';


const Webinars = () => {

    return (
        <div className='portifoliobody'>
            <main id="main">
                <section id="webinars" className="about text-start" style={{paddingTop:'70px'}}>
                    <div className="blg-title">
                        <div className="blg-title-bg-img" style={{overflow:'hidden'}}><img src={bg_dot_hero} alt="" style={{ width:'inherit'}}/></div>
                        <div data-aos="fade-right" data-aos-delay="100">
                            <h1>Webinars</h1>
                            <p>Learn from industry leaders through our on-demand and events covering key compliance and tech topics.</p>
                        </div>
                    </div>
                    <div style={{padding:'100px 0', border:'1px solid'}}>
                        <div>
                            
                        </div>
                    </div>

                </section>
            </main>
        </div>
    )
}

export default Webinars;


const wps = [
    {
        'title' : 'Key features and benifits of Lims',
        'content' : 'A LIMS system streamlines lab operations, ensures data integrity, boosts productivity, enhances compliance, and enables real-time decision-making with automation.',
    },
    {
        'title' : 'LIMS: SECURE. COMPLIANT. RELIABLE.',
        'content' : 'Protects lab data, ensures regulatory compliance, enables audit trails, and supports accurate, efficient, and trustworthy laboratory operations.',
    }
];